const mapLabelsToValues = (dataToTrack, attr) => {
  return Array.isArray(dataToTrack[attr])
    ? dataToTrack[attr].map(({ label, value }) => label ?? value).join(', ')
    : (dataToTrack[attr].label ?? dataToTrack[attr].value)
}

const buildAudienceObjectTrack = trackedObj => {
  return {
    Genders: mapLabelsToValues(trackedObj, 'audienceGenders'),
    Ages: mapLabelsToValues(trackedObj, 'audienceAges'),
    'Filtered Country': mapLabelsToValues(trackedObj, 'audienceCountries'),
  }
}

export default buildAudienceObjectTrack
